import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { SFFormBuilder } from "@sf-core";

import getSchema from "./schema.js";
import getUiSchema from "./uischema.js";

const AddUserTenantForm = ({ onChange, data }) => {
  const [schema, setSchema] = useState(null);
  const [uischema, setUischema] = useState(null);
  const [formData, setFormData] = useState(data);

  useEffect(async () => {
    const schema = await getSchema(data);
    setSchema(schema);
    setUischema(getUiSchema(schema));
  }, [data?.tenantId]);

  const changeHandler = async (curData, errors) => {
    if (curData.tenantId !== formData.tenantId) {
      setSchema(
        await getSchema({
          tenants: curData.tenants,
          tenantId: curData.tenantId,
        })
      );
    }
    onChange({ curData, prevData: formData, errors });
    setFormData(curData);
  };

  if (!schema || !uischema) return null;

  return (
    <SFFormBuilder
      schema={schema}
      uischema={uischema}
      data={data}
      onChange={changeHandler}
    />
  );
};

AddUserTenantForm.propTypes = {
  data: PropTypes.object.isRequired,
};

export default AddUserTenantForm;
